export type RangePreset = {
  key: string;
  label: string;
  days: number;
};

export const RANGE_PRESETS: readonly RangePreset[] = [
  { key: '1', label: 'Idag', days: 0 },
  { key: '7', label: 'Senaste 7 dagarna', days: 6 },
  { key: '30', label: 'Senaste 30 dagarna', days: 29 },
];

export const stockholmToday = (): string => {
  const parts = new Intl.DateTimeFormat('sv-SE', {
    timeZone: 'Europe/Stockholm',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(new Date());
  const get = (type: string) => parts.find((part) => part.type === type)?.value ?? '';
  return `${get('year')}-${get('month')}-${get('day')}`;
};

// Räknas i UTC med avsikt: datumen är rena kalenderdatum, och UTC saknar
// sommartidsskiften som annars gör att ett dygn ibland blir 23 eller 25 timmar.
export const addDays = (date: string, delta: number): string => {
  const [year, month, day] = date.split('-').map(Number);
  return new Date(Date.UTC(year, month - 1, day + delta)).toISOString().slice(0, 10);
};

export const rangeSpanDays = (fromDate: string, toDate: string): number => {
  const ms =
    new Date(`${toDate}T23:59:59Z`).getTime() - new Date(`${fromDate}T00:00:00Z`).getTime();
  return Math.max(1, Math.ceil(ms / (24 * 60 * 60 * 1000)));
};

export const findActivePresetKey = (
  fromDate: string,
  toDate: string,
  today: string,
): string | null =>
  RANGE_PRESETS.find((preset) => toDate === today && fromDate === addDays(today, -preset.days))
    ?.key ?? null;

export type SessionRange = {
  fromDate: string;
  toDate: string;
  fromTime: string;
  toTime: string;
};

export const presetRange = (today: string, days: number): SessionRange => ({
  fromDate: addDays(today, -days),
  toDate: today,
  fromTime: '00:00',
  toTime: '23:59',
});
